import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
//Material imports
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button"; //Limitless imports

import { smileyAmber, smileyRed, smileyGreen } from "@limitless/images";

var SmileyRatingSystem = function SmileyRatingSystem(_ref) {
  var classes = _ref.classes,
      _onClick = _ref.onClick,
      disabled = _ref.disabled,
      rating = _ref.rating,
      compact = _ref.compact,
      containerClass = _ref.containerClass;

  var _React$useState = React.useState(rating),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      localRating = _React$useState2[0],
      setLocalRating = _React$useState2[1];

  React.useEffect(function () {
    setLocalRating(rating);
  }, [rating]);

  var renderSmiley = function renderSmiley(assetName, id, score, unselectedOpacity) {
    var selected = localRating === score;
    var hide = !selected && compact;
    var selectedClass = "";
    var buttonStyles = {};

    if (localRating !== -1) {
      selectedClass = "".concat(selected ? classes.buttonSelected : classes.buttonUnSelected);
      buttonStyles = selected ? {} : {
        opacity: unselectedOpacity
      };
    }

    var props = {
      classes: {
        root: "".concat(selectedClass, " ").concat(classes.smileyHover, " ").concat(compact ? classes.compact : "")
      },
      disabled: disabled,
      className: classes.csatSimleyButton,
      component: "div",
      style: hide ? {
        display: "none"
      } : buttonStyles,
      enabled: selected.toString()
    };

    if (!disabled) {
      props = _objectSpread({
        onClick: function onClick() {
          setLocalRating(score);

          _onClick(score);
        }
      }, props);
    }

    return /*#__PURE__*/React.createElement(Button, Object.assign({}, props, {
      id: id
    }), /*#__PURE__*/React.createElement("img", {
      src: assetName,
      className: "".concat(classes.smileyImage, " ").concat(selected && !compact ? classes.smileyImageSelected : "")
    }));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smileyContainer, " ").concat(containerClass),
    rating: localRating
  }, renderSmiley(smileyRed, "redVoteButton", 1, 0.4), renderSmiley(smileyAmber, "amberVoteButton", 2, 1), renderSmiley(smileyGreen, "greenVoteButton", 3, 0.7));
};

var styles = function styles(_ref2) {
  var palette = _ref2.palette;
  var smileySelectedBackground = "#f5f5f5";
  var smileySelectedBorderColor = "1px solid rgba(163,168,168, 0.5)";
  var smileySelectedBorderRadius = 4;

  if (palette.smiley) {
    smileySelectedBackground = palette.smiley.fill;
    smileySelectedBorderColor = palette.smiley.border;
    smileySelectedBorderRadius = palette.smiley.borderRadius;
  }

  return {
    smileyImage: {
      transition: "all .2s linear",
      width: 32,
      height: 32,
      "&:hover": {
        transform: "scale(1.15)"
      }
    },
    smileyImageSelected: {
      transform: "scale(1.15)"
    },
    smileyContainer: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between"
    },
    smileyHover: {
      "&:hover": {
        backgroundColor: smileySelectedBackground,
        borderRadius: smileySelectedBorderRadius,
        filter: "none",
        opacity: "1 !important"
      }
    },
    csatSimleyButton: {
      padding: 1,
      boxShadow: "none",
      cursor: "pointer",
      border: 0,
      borderRadius: 0,
      height: 52,
      width: 64,
      "&:disabled": {
        cursor: "default",
        opacity: "0.2"
      },
      "&:focus": {
        outline: "none"
      }
    },
    buttonDisabled: {
      "&:hover, &.Mui-focusVisible": {
        backgroundColor: "transparent"
      },
      cursor: "default"
    },
    buttonSelected: {
      backgroundColor: smileySelectedBackground,
      borderRadius: smileySelectedBorderRadius,
      border: smileySelectedBorderColor,
      margin: 0
    },
    buttonUnSelected: {
      filter: "grayscale(100%)"
    },
    compact: {
      transform: "scale(0.9)",
      height: "unset",
      width: "unset",
      backgroundColor: "unset",
      padding: 0,
      minWidth: "unset",
      border: "none"
    }
  };
};

export default withStyles(styles)(SmileyRatingSystem);
SmileyRatingSystem.defaultProps = {
  compact: false
};